import type { Role } from "src/api/client-api/roles/useGetRole";

export const ROLE_ADMIN = "ROLE_ADMIN";
export const ROLE_USER = "ROLE_USER";

export const isPlatformAdmin = (roles: string[] | undefined): boolean => (roles ?? []).includes(ROLE_ADMIN);

export const canManagePlatformAdminTarget = (actorIsPlatformAdmin: boolean, targetRoles: string[] | undefined) =>
    actorIsPlatformAdmin || !isPlatformAdmin(targetRoles);

export const derivePlatformRoleOptions = (
    roles: Role[] | undefined,
    getRoleDisplayName: (code: string) => string,
): string[] =>
    (roles ?? [])
        .filter((role) => role.scope === "platform" && role.code !== ROLE_ADMIN)
        .map((role) => role.code)
        .sort((a, b) => getRoleDisplayName(a).localeCompare(getRoleDisplayName(b)));

export const deriveOrganizationRoleOptions = (
    roles: Role[] | undefined,
    getRoleDisplayName: (code: string) => string,
): string[] =>
    (roles ?? [])
        .filter((role) => role.scope !== "platform" && role.code !== ROLE_USER && role.code !== ROLE_ADMIN)
        .map((role) => role.code)
        .sort((a, b) => getRoleDisplayName(a).localeCompare(getRoleDisplayName(b)));

export const selectPlatformRoleCodes = (roles: string[] | undefined, platformRoleOptions: string[]): string[] => {
    const allowed = new Set(platformRoleOptions);
    return (roles ?? []).filter((code) => allowed.has(code));
};

export const shouldSubmitRolesOnEdit = (
    isPlatformAdminActor: boolean,
    dirtyFields: { platformAdmin?: boolean; roles?: boolean | readonly (boolean | undefined)[] },
): boolean => {
    const rolesChanged =
        Array.isArray(dirtyFields.roles) ? dirtyFields.roles.some(Boolean) : Boolean(dirtyFields.roles);

    return isPlatformAdminActor && (Boolean(dirtyFields.platformAdmin) || rolesChanged);
};
